import React, { Component } from 'react'
import NavbarComp from './NavbarComp';
import Mycard from './Mycard';
import Row from 'react-bootstrap/Row';
import Thiscard from './Thiscard';
import Travel from './Travel';
import Footer from './Footer';
import Figure from 'react-bootstrap/Figure';
import Col from 'react-bootstrap/Col';



export default class 

 extends Component {
 
  render() {
    return (
      <div>
        <NavbarComp />
    
        
  <div className='web  '>
    <div className='web1 text-white fw-bold '>
      <h6 className='animated fadeInUp ease-in-quint d-1 a-2 ms-2 mt-2 '>STEERING AMCOSA TOWARDS</h6>
      <h1 className='animated fadeInUp ease-in-quint d-1 a-2 text-center offset-1'>Center of Excellence in Education Soon</h1>
<p className=' col-10 offset-1 animated fadeInUp ease-in-quint d-1 a-2'>Our objective is to make AMCOSA a center excellence in science education in Nigeria. Academically strong and one of the top 50 schools in the country. Our top priority is to rebuild, renovate and maintain the Physics, Chemistry and Biology laboratories. Exposing students to Science, Technology, Engineering, Arts, and Mathematics  and giving them opportunities to explore  and develop a passion for it.</p>
    
<div class="contain mb-4">
    <a className='aa' href="/excellence">
      <span>Learn More</span>
    </a>
   
    </div>
    </div>
   
  </div>
       <div>
        <Row>
        <Mycard   tittle={'Excellence Capital Campaign'} img={'alu'} description={'When you become a dues paying member, you are identifying yourself as a proud AMCOSITE who has a stake in the association’s future.'} icon={'fa fa-adjust'}  btn={'Learn more'} link={'/excellence'}/> 
        <Mycard  tittle={'Photo Gallery'} img={'am2'} description={'Photographs and videos   reminds us of what was important to us.It triggers memories that are long gone faded and brings them back to life.Watch photos and videos of past events, programs, and happenings at AMCOSA and our dear Alma Mater.'} icon={'fa fa-picture-o'} btn={'Watch Now'} link={'/gallery'}/> 
       <Mycard  tittle={'offering networking opportunities'} img={'como1'} description={'AMCOSA is looking forward to offer offer networking opportunities, which can connect recent graduates with established professionals and help people pursue career changes. '} btn={'connect'} icon={'fa fa-cloud'} type="alert"/> 
       <Mycard  tittle={'Membership Registration'} img={'como2'} description={'Went to  AS SALAM model college,  Register with us to become a member so we can keep you up to date on all AMCOSA news.having an alma mater in common and being able to network via regular in-person events or online platforms for connections.'}  icon={'fa fa-registered'} btn={'Register Now' } link={'/reg'}/> 
       <Mycard  tittle={'Annual Dues'} img={'an'} description={'When you become a dues paying member, you are identifying yourself as a proud Grammarian who has a stake in the school’s future.'} icon={'fa fa-money'} btn={'Pay Now'} type="alert"/> 
       <Mycard  tittle={'Give to programme'} img={'give'} description={'Your financial donation can make the biggest and most immediate impact to the current needs, enriching and empowering our Alma Mater.Your own donations can inspire your nearest and dearest to give to causes important to them '}  icon={'fa fa-money'} type="alert" btn={'Give Now'}/> 
        </Row>
       
       

       </div> 
       <div className='text-center mt-5'>
        <h1>Quest Towards a Center of Excellence.</h1>
        <p className='col-10 text-center offset-1 fw-bold'>Leverage Technology – Open the School Community to plethora of information and knowledge resource. 
Leverage Old Students’ Network – Spreading & Sharing the Tasks.
Incorporate Elements of Sustainability.</p>
       </div>
       
       <div className='old col-12 mt-5 overflow-hidden '>
        <div className='mt-3  text-center'><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i></div>
        <h2 className='mt-4 col-10 col-lg-12 offset-1 offset-lg-0  text-center '>OLD STUDENTS ARE MAKING A DIFFERENCE EVERYDAY</h2>
        <p className=' mt-3 col-10 col-lg-12 offset-1 offset-lg-0  text-center '>Membership is one of the simplest, most meaningful and most affordable ways to give back to our School.</p>
        <a className='btt ' href="#" class='rainbow-button offset-5' alt="Join Now"></a>
        <div className='mb-3 mt-2  text-center'><i class="fa fa-star" aria-hidden="true"><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i></div>
       </div>
       <div>
     <Row>
   <Thiscard  tittle={'AMCOSA Forum'} img={'code_128'} description={'Something on your mind? The AMCOSA Forum is a place for respectful conversation and debate about our Old School related issues, ways to help and ways forward. A place to reminisce and go down memory lane together. A place to talk about the future and respond to the emerging needs of our dear school.'} btn={'Join Forum'} link={'https://www.facebook.com/groups/2182329605125217/?ref=share'}/>
   <Thiscard  tittle={'Invite a Member'} img={'design_128'} description={'Do you know an old student interested in AMCOSA? Would he or she like to informally speak with an alum or someone in the executive? Send out an invitation using this tool and connect the old student with AMCOSA. We need every member to get involved. Lets make a difference together'} btn={'Invite Now'}  link={'https://chat.whatsapp.com/GShS3aL1IZSLbzTEhTMGwP'}/>
   <Thiscard  tittle={'Give to AMCOSA'} img={'launch_128'} description={'You can make a gift to the AMCOSA and you can designate the gift in honor of or in memory of someone special. Your gift will go a long way to provide much needed resources for a great education for current students of As salam model college. Give TODAY!'} btn={'Give Now'}/>
   </Row>
     </div>

     <div>
<Row>
        <Col className='row-1' sm={6}>
        <h5 className='text-white text-center fw-bold fs-3 mt-4'>An Unwavering Mission</h5>
            <p className='text-white offset-1 col-10 col-g-6'>
            For  years, at the heart and soul of AS SALAM model college is a commitment to developing the fullest potential of every student in learning, faith, and leadership.

The AS SALAM model college old students association (AMCOSA) is made up of old students of the school who make a difference every day. The unwaivering mission of AMCOSA is to foster a lifelong relationship between our alma mater and its old students and to meet the numerous challenges facing the school today while strengthening the sustainability of projects we have embarked on.
            </p>
        </Col>
        
        
        
        <Col className='row-2 overflow-hidden' sm={6}>
    


<Figure>
      <Figure.Image
        width={1000}
        height={400}
        alt="171x180"
        src={require('../video/am3.jpg')}
      />
      
    </Figure>
        </Col>
      </Row>

</div>

 <div className='exe-2 text-center'>
  <div className='overlays'>
    <h1 className='text-white'>OUR  PLANS  </h1>
    <details>
  <summary>Maintenance of the Physics, Chemistry and biology Labs </summary>
  <div class="content">
    <p>
    Physical maintenance of the Physics, Chemistry and Biology laboratories, equipment and multimedia systems.
Purchase of reagents, educational videos, books, electronic materials/tutorials and supplies for the laboratories, ICT Center and e-library as well as Insurance to protect the assets.
    </p>
   <Travel  img={'ex1'} />
   
  </div>
</details>
<details>
  <summary>Continous Yearly Gift and scolarships</summary>
  <div class="content">
    <p>
    we  desires to keep the school tuition-free for some students through scolarships.
    </p>
   <Travel img={'sk'} />
   
  </div>
</details>
<details>
  <summary>AMCOSA connect</summary>
  <div class="content">
    <p>
    AMCOSA is looking forward to offer offer networking opportunities, which can connect recent graduates with established professionals and help people pursue career changes.
    </p>
    <Travel img={'skl'} />
  
  </div>
</details>
<details>
  <summary>intellectual development</summary>
  <div class="content">
    <p>
    To organize programs, which inspire and motivate the young students for their intellectual development.
    </p>
    <Travel img={'verr'} />
   
  </div>
</details>
<details>
  <summary>Employement updates for members</summary>
  <div class="content">
    <p>
    To provide information of employment opportunities and support whatever possible. To undertake or to do all other things, which may include similar corresponding support, correlated, incidental, necessary matters which may be found by the Executive Committee from time to time to be conducive for the achievement of all or any of the objectives stated in above.
    </p>
  
    <Travel img={'ver'} />
  </div>
</details>

</div>


        </div>


{/* 
       { <section className='col-12 overflow-hidden mt-5'>
       
            <video className='cof' src={ink} autoPlay loop muted />
            
            <div id="wrapper">
    <div id="containery">
    <h4 className='tex text-center mt-5'>OUR UPCOMING EVENTS.</h4>
       <h3 className='tex text-center mt-4'>cheers</h3>
        <h1 className='tex text-center mt-1'>AMCOSA @ 10.</h1>
        <h4 className='tex text-center mt-1 mb-4'>coming soon.</h4>
    </div>
</div>
  
 </section> } */}

<div className=' col-12 overflow-hidden bg-light  '>
<Row>
<p  className='text-center text-dark fw-bold fs-4 mt-3' >Adventure Awaits You in Our 2023 Travel Collection</p>

<Travel img={'tra12'} />
<Travel img={'tra13'} />
<Travel img={'tra14'} />
<Travel img={'tra15'} />
</Row>
<a className='btt ' href="tel:+2348131515156" class='rainbow-button offset-5 mb-3' alt="Book Now"></a>
</div>

<div className='ads col-12  text-white overflow-hidden'>
  <h1 className='text-center mt-3'>Advertistments</h1>
 
<Row>
<Mycard img={'spicy'} tittle={'SPICEO'}  description={' All natural ingredientsNo MSG,No sugar,Low sodium  Safe for adults and children,Safe for weight loss plan,Safe for diabetic and hypertensive patients. Enter dm now or contact us on 08166733421 to get yours   '} btn={'watsapp'} link={'http://bit.ly/Spicehub'}  />
 

  <Mycard img={'d9'} tittle={'DREAM9ATION EXCHANGE'} description={'Let us show you the value of your crypto coins.Trade with #Dream9ation #Exchange today! #Dream9ation #payoneer #PayPal #bitcoins #Ethereum #Giftcards'} btn={'website'} link={'https://www.dream9ation.com/'}  />

  <Mycard img={'akm'} tittle={'AKOJEL ICT 08062456354'}  description={'Information and communication technology. our brand is offering website design, programming, training and corporate branding..' } btn={'website'} link={'https://akojelict.netlify.app'} />

  <Mycard img={'pally'} tittle={'TRADE AT EASE WITH MYPALLY'} description={'over the years transacting PayPal funds in Nigeria comes with difficulty. Either fear of losing fund, restriction or scam. With MyPally, you can transact, buy, sell and recieve funds with ease'} btn={'website'} link={'https://mypally.co'}   />
  
  <Mycard img={'muba'} tittle={'ORIFLAME COSMETIC SWEDEN WHATSSAPP:09065921033  FACEBOOK:Abidola Mubarokah Olasunkade IG:lasunkade77'} description={'My name is Mubarokah, now a beauty/skincare consultant with *ORIFLAME cosmetics Sweden* . We deal on beauty products ranging from skin cares, fragrances, colour cosmetics (makeups), hair cares, basically what we use from head to toe, for both men and women. I am now ur go-to girl on anything *Oriflame products*'} btn={'whatsapp'}  link={'https://wa.me/23409065921033?text='} />

</Row>
</div>
<div>


<Footer />
</div>
  </div>
 
      
    )
  }
}
